import { erpAxios, getAuthToken } from "../axiosInstances";

export class DownloadPdfApi {
  public static api = new DownloadPdfApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getPdfLinkByPOId(id: number | null): Promise<void> {
    try {
      const response = await this.instance.get(
        `/erp/api/v1/purchase-order/${id}/pdf`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          responseType: "blob",
        }
      );

      if (response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `purchase-order-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading PDF", error);
      throw error;
    }
  }

  async getPdfLinkByDOId(id: number | null): Promise<void> {
    try {
      const response = await this.instance.get(
        `/erp/api/v1/delivery-order/${id}/pdf`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          responseType: "blob",
        }
      );

      if (response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `delivery-order-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading PDF", error);
      throw error;
    }
  }

  async getPdfLinkByTOId(id: number | null): Promise<void> {
    try {
      const response = await this.instance.get(
        `/erp/api/v1/transfer-order/${id}/pdf`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          responseType: "blob",
        }
      );

      if (response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `transfer-order-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading PDF", error);
      throw error;
    }
  }

  async getPdfLinkBySOId(id: number | null): Promise<void> {
    try {
      const response = await this.instance.get(
        `/erp/api/v1/inventory/download/so?orderId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          responseType: "blob",
        }
      );

      if (response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `sales-order-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading PDF", error);
      throw error;
    }
  }

  async downloadSalesOrderPdf(id: number | null): Promise<void> {
    try {
      const response = await this.instance.get(
        `/erp/api/v1/inventory/download/so?orderId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: { soId: id },
          responseType: "blob",
        }
      );

      if (response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `sales-order-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading Sales Order PDF", error);
      throw error;
    }
  }
}
